import React, {useEffect, useRef} from 'react';


interface SelectProps  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  options?: Array<any>
}


export function Select(props: SelectProps) {

  const ele = useRef(null);

  useEffect(() => {
    const $el = $(ele.current!) as any;

    $el.selectpicker();

    return () => {
      $el.selectpicker("destroy");
    };
  }, []);

  useEffect(() => {
    const $el = $(ele.current!) as any;
    $el.selectpicker("refresh");
  }, [props.children]);

  return(
    <>
      <select data-live-search="true" {...props} ref={ele}>
        {props.children}
      </select>
    </>
  )
}